import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getRegions } from 'actions'
import { Header, Footer } from '../'
import { ScrollToTop } from 'components/common'
import HistoryManagerProvider from 'components/hooks/HistoryManagerProvider'
import s from './Layout.module.css'
import ScrollY from 'components/ScrollY/ScrollY'

const Layout = ({ children }) => {
  const regions = useSelector((state) => state.homepage.regions.data)
  const isMobile =
    typeof window !== 'undefined' ? window.innerWidth < 980 : false

  const dispatch = useDispatch()

  useEffect(() => {
    if (!regions.length) {
      dispatch(getRegions())
    }
  }, [])

  return (
    <HistoryManagerProvider>
      <div className="pt-[43px] xl:pt-[71px]">
        <Header />
        {!isMobile && (
          <ScrollY>
            {(pageOffset) => <ScrollToTop pageOffset={pageOffset} />}
          </ScrollY>
        )}
        <div className={s.container}>{children}</div>
        <Footer />
      </div>
    </HistoryManagerProvider>
  )
}

export default Layout
